<div class="container py-4">
  <app-breadcrumbs
  [items]="[
    { label: 'Productos', url: '/productos' },
  ]">
</app-breadcrumbs>
  <!-- Encabezado con título, volver y nuevo -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div class="d-flex align-items-center gap-2">
      <button class="btn btn-outline-secondary" (click)="volverAtras()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h3 class="text-primary mb-0">
        <i class="fa-solid fa-boxes-stacked me-2"></i>Productos
      </h3>
    </div>
    <a routerLink="/productos/nuevo" class="btn btn-success">
      <i class="fa-solid fa-plus me-2"></i>Nuevo Producto
    </a>
  </div>

  <!-- Tabla -->
  <div class="card shadow-sm border-0">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-striped mb-0 align-middle">
          <thead class="table-light">
            <tr>
              <th>Nombre</th>
              <th>Precio</th>
              <th style="width: 180px;">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of productos">
              <td class="fw-semibold">{{ p.nombre }}</td>
              <td class="text-success fw-bold">{{ p.precio | currency:'ARS':'symbol':'1.2-2' }}</td>
              <td>
                <div class="d-flex gap-2">
                  <a [routerLink]="['/productos/editar', p.productoId]" class="btn btn-sm btn-outline-primary">
                    <i class="fa-solid fa-pen-to-square me-1"></i>Editar
                  </a>
                  <button (click)="eliminarProducto(p.productoId)" class="btn btn-sm btn-outline-danger">
                    <i class="fa-solid fa-trash me-1"></i>Eliminar
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
